// src/components/Sidebar.jsx
import React from "react";
import "./Sidebar.css";

import {
  Home,
  Repeat,
  Clock,
  BarChart2,
  Trophy,
  Settings,
  LogOut,
  X
} from "lucide-react";

import { useNavigate } from "react-router-dom";

export default function Sidebar({ open, onClose, onLeaderboardToggle }) {
  const navigate = useNavigate();

  return (
    <>
      {/* DARK OVERLAY */}
      {open && <div className="overlay" onClick={onClose}></div>}

      {/* ---------------- FULL SIDEBAR ---------------- */}
      <div className={`sidebar-full ${open ? "show" : ""}`}>
        <button className="closeBtn" onClick={onClose}>
          <X size={22} />
        </button>

        <h2 className="logo">Menu</h2>

        <nav>
          <button className="item" onClick={() => navigate("/")}>
            <Home size={18} /> Dashboard
          </button>

          <button className="item" onClick={() => navigate("/transactions")}>
            <Repeat size={18} /> Transactions
          </button>

          <button className="item" onClick={() => navigate("/earnings")}>
            <Clock size={18} /> Earnings
          </button>

          <button className="item" onClick={() => navigate("/Packages")}>
            <BarChart2 size={18} /> Packages
          </button>

          <button className="item" onClick={onLeaderboardToggle}>
            <Trophy size={18} /> Leaderboard
          </button>

          <button className="item" onClick={() => navigate("/settings")}>
            <Settings size={18} /> Settings
          </button>
        </nav>

        <button className="logout-btn">
          <LogOut size={16} /> Logout
        </button>
      </div>

      {/* ---------------- MINI SIDEBAR (DESKTOP LEFT + MOBILE BOTTOM) ---------------- */}
      <div className="mini-sidebar">

        <button className="mini-icon-btn" onClick={() => navigate("/")}>
          <Home size={20} />
        </button>

        <button className="mini-icon-btn" onClick={() => navigate("/transactions")}>
          <Repeat size={20} />
        </button>

        <button className="mini-icon-btn" onClick={() => navigate("/earnings")}>
          <Clock size={20} />
        </button>

        <button className="mini-icon-btn" onClick={() => navigate("/Packages")}>
          <BarChart2 size={20} />
        </button>

        <button className="mini-icon-btn" onClick={onLeaderboardToggle}>
          <Trophy size={20} />
        </button>

        <button className="mini-icon-btn" onClick={() => navigate("/settings")}>
          <Settings size={20} />
        </button>

        <div className="mini-bottom">
          <button className="mini-icon-btn">
            <LogOut size={20} />
          </button>
        </div>

      </div>
    </>
  );
}
